import {
  registerTableHandleColumnMenuRootElement,
  registerTableHandleColumnMenuTriggerElement,
  registerTableHandleColumnPopupElement,
  registerTableHandleColumnPositionerElement,
  registerTableHandleDragPreviewElement,
  registerTableHandleDropIndicatorElement,
  registerTableHandleRootElement,
  registerTableHandleRowMenuRootElement,
  registerTableHandleRowMenuTriggerElement,
  registerTableHandleRowPopupElement,
  registerTableHandleRowPositionerElement,
} from '@prosekit/web/table-handle'

export * from '@prosekit/web/table-handle'

export {
  TableHandleColumnMenuRootElement as TableHandleColumnMenuRoot,
  TableHandleColumnMenuTriggerElement as TableHandleColumnMenuTrigger,
  TableHandleColumnPopupElement as TableHandleColumnPopup,
  TableHandleColumnPositionerElement as TableHandleColumnPositioner,
  TableHandleDragPreviewElement as TableHandleDragPreview,
  TableHandleDropIndicatorElement as TableHandleDropIndicator,
  TableHandleRootElement as TableHandleRoot,
  TableHandleRowMenuRootElement as TableHandleRowMenuRoot,
  TableHandleRowMenuTriggerElement as TableHandleRowMenuTrigger,
  TableHandleRowPopupElement as TableHandleRowPopup,
  TableHandleRowPositionerElement as TableHandleRowPositioner,
} from '@prosekit/web/table-handle'

registerTableHandleRootElement()
registerTableHandleDragPreviewElement()
registerTableHandleDropIndicatorElement()
registerTableHandleColumnPositionerElement()
registerTableHandleColumnPopupElement()
registerTableHandleColumnMenuRootElement()
registerTableHandleColumnMenuTriggerElement()
registerTableHandleRowPositionerElement()
registerTableHandleRowPopupElement()
registerTableHandleRowMenuRootElement()
registerTableHandleRowMenuTriggerElement()
